import { useState, useEffect, Fragment, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { useSpeechSDK } from '../../Helpers/Conversation/SpeechDetection';
import { createAudioFromBlob } from '../../Helpers/Util/AudioHelpers';

const ButtonAudioPlayer = () => {
  const [buttonAudioSource, setButtonAudioSource] = useState('');
  const audioBlobs = useSelector((state) => state.audioBlobs);
  const activeSection = useSelector((state) => state.activeSection);
  const playButtonAudio = useSelector((state) => state.playButtonAudio);
  const preteachActive = useSelector((state) => state.preteachActive);
  const buttonOrder = useSelector((state) => state.buttonOrder);
  const dispatch = useDispatch();
  const button_player = useRef();

  const playMainAudio = () => {
    button_player.current.load();
    button_player.current.play().catch((error) => {
      console.warn(`Couldn't play main audio: ${error}`);
    });
  };

  useEffect(() => {
    if (audioBlobs.length !== 0) {
      setButtonAudioSource(createAudioFromBlob(audioBlobs[0][1]));
    }
  }, [audioBlobs]);

  useEffect(() => {
    if (playButtonAudio === true) {
      let buttonURL = '';
      try {
        buttonURL = createAudioFromBlob(audioBlobs[activeSection][buttonOrder]);
      } catch (error) {
        console.warn(error);
      }

      if (buttonURL !== '') {
        setButtonAudioSource(buttonURL);

        //Don't play first button through dispatch to get around safari autoplay policy
        if (
          useSpeechSDK() &&
          buttonOrder === 1 &&
          activeSection === 0 &&
          preteachActive === false
        )
          return;
        playMainAudio();
      }
    }

    if (playButtonAudio === false && buttonAudioSource !== '') {
      // setButtonAudioSource('')
      URL.revokeObjectURL(buttonAudioSource);
    }
  }, [playButtonAudio]);

  useEffect(() => {
    if (button_player && button_player.current) {
      button_player.current.addEventListener('ended', function () {
        dispatch({
          type: 'stopButtonAudio',
        });
      });

      button_player.current.addEventListener('error', () => {
        //TODO: add logging here
        dispatch({
          type: 'stopButtonAudio',
        });
      });

      // button_player.current.addEventListener('abort', () => {
      //   console.log('aborted');
      // });

      // button_player.current.addEventListener('canplay', (event) => {
      // 	console.log('can play');
      // });

      // button_player.current.addEventListener('loadeddata', (event) => {
      // 	console.log('loaded data');
      // });

      // button_player.current.addEventListener('play', (event) => {
      // 	console.log('playing');
      // });

      // button_player.current.addEventListener('paused', (event) => {
      // 	console.log('paused');
      // });

      // button_player.current.addEventListener('progress', (event) => {
      // 	console.log('progress');
      // });

      button_player.current.addEventListener('stalled', () => {
        //TODO: add logging here
        dispatch({
          type: 'stopButtonAudio',
        });
      });

      // button_player.current.addEventListener('suspend', (event) => {
      // 	console.log('suspended');
      // });

      // button_player.current.addEventListener('waiting', (event) => {
      // 	console.log('waiting');
      // });

      // button_player.current.addEventListener('loadedmetadata', (event) => {
      // 	console.log('loadedmeta');
      // 	setIsFetching(false);
      // });
    }
  }, [buttonAudioSource]);

  return (
    <Fragment>
      {buttonAudioSource && (
        <audio id="button_audio_player" ref={button_player}>
          <source
            id="button_player_source"
            src={buttonAudioSource}
            type="audio/mpeg"
          />
        </audio>
      )}
    </Fragment>
  );
};

export default ButtonAudioPlayer;
